import Localize from 'app/src/localize/Localize';

import {
  checkForMultipleGiftCards,
  randomGenerateGiftCardCode,
  removeErrorMessage,
  toggleElectronicDetails,
  updateCharCount,
} from './event_listeners';

window.merchantos.omniGiftCard = {
  eventListeners: {
    checkForMultipleGiftCards,
    randomGenerateGiftCardCode,
    toggleElectronicDetails,
    updateCharCount,
    removeErrorMessage,
  },
};

function refreshGiftCards(): void {
  const input = document.getElementById('new_gift_card_code') as HTMLInputElement | null;
  const value = input?.value;

  if (value) {
    checkForMultipleGiftCards(value);
  }
}

const validateRequiredFields = (): boolean => {
  const requiredInputs = [
    'gift_card_recipient_name',
    'gift_card_email_to',
    'gift_card_sender_name',
  ];
  let allValid = true;
  const toggle = document.getElementById('electronic-delivery-toggle') as HTMLInputElement | null;
  if (!toggle?.checked) {
    return allValid;
  }

  requiredInputs.forEach((id) => {
    const inputElem = document.getElementById(id) as HTMLInputElement;
    const errorMessageElem = document.getElementById(`${id}-error`);

    if (!inputElem.value.trim()) {
      allValid = false;
      inputElem.style.borderColor = 'red';

      if (!errorMessageElem) {
        const errorDiv = document.createElement('div');
        errorDiv.id = `${id}-error`;
        errorDiv.textContent = Localize.translate('This field is required');
        errorDiv.classList.add('ogc-error');
        inputElem.parentNode?.insertBefore(errorDiv, inputElem.nextSibling);
      }
    } else {
      inputElem.style.borderColor = '';
      if (errorMessageElem) {
        errorMessageElem.remove();
      }
    }
  });

  return allValid;
};

const onFormSubmit = (event: Event): void => {
  if (!validateRequiredFields()) {
    event.preventDefault();
  }
  const codeInput = (document.querySelector('input[name="code"]:checked') ??
    document.querySelector('input[name="code"]')) as HTMLInputElement | null;
  const uuidInput = document.getElementById('gift_card_uuid') as HTMLInputElement | null;

  if (uuidInput) {
    uuidInput.value = codeInput?.dataset.uuid ?? '';
  }
};

const watchFormSubmit = (): void => {
  const form = document.getElementById('form-register-omni-gift-card') as HTMLFormElement | null;

  form?.removeEventListener('submit', onFormSubmit);
  form?.addEventListener('submit', onFormSubmit);
};

$(function () {
  const hasOmniGc = window.lsCloud.Modules.hasModule('omni.giftcards');

  if (hasOmniGc) {
    watchFormSubmit();
    refreshGiftCards();
  }
});
